import cookie from 'cookie';
import _set from 'lodash/set';

const trackingMapping: Record<string, string> = {
  referrer: 'page.referrer',
  utm_campaign: 'campaign.name',
  utm_source: 'campaign.source',
  utm_medium: 'campaign.medium',
  utm_content: 'campaign.content',
  utm_term: 'campaign.term'
};

const trackingKeys = Object.keys(trackingMapping);

export function parseTrackingCookie(cookieStr: string) {
  const parsed = cookie.parse(cookieStr);
  return trackingKeys.reduce((result, key) => {
    const value = parsed[key];
    if (value && value !== 'null') {
      return _set(result, trackingMapping[key], value);
    }

    return result;
  }, {});
}
